import { useState } from "react";
import { Smartphone, Check, RefreshCw } from "lucide-react";
import { api, formatErr } from "@/lib/api";

export default function WalletPanel({ cardKey, card, onEnabled }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const ready = !!card?.wallet?.enabled_at;

  const enable = async () => {
    setBusy(true); setErr("");
    try { await api.post(`/banking/cards/${cardKey}/wallet`); onEnabled?.(); }
    catch (e) { setErr(formatErr(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-3 bg-cream border border-sand rounded-lg p-3" data-testid={`wallet-panel-${cardKey}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] font-semibold text-sage">
          <Smartphone className="w-3.5 h-3.5" /> Apple Pay · Google Pay
        </div>
        {ready
          ? <span className="inline-flex items-center gap-1 text-[10px] font-medium text-forest" data-testid={`wallet-ready-${cardKey}`}><Check className="w-3 h-3" /> Wallet-ready</span>
          : <button onClick={enable} disabled={busy} className="text-[11px] font-medium text-forest border border-forest rounded-md px-2 py-1 hover:bg-forest hover:text-white disabled:opacity-50 inline-flex items-center gap-1" data-testid={`wallet-enable-${cardKey}`}>
              <RefreshCw className={`w-3 h-3 ${busy ? "animate-spin" : ""}`} /> {busy ? "Enabling…" : "Enable wallet"}
            </button>}
      </div>
      <div className="mt-2 text-[11px] text-moss leading-relaxed">
        {ready
          ? <>Open the Wallet app → <strong className="text-ink">+</strong> → Debit or Credit Card → Enter Card Details Manually, then type the number, expiry and CVV from <strong className="text-ink">Show card number</strong>. A verification code goes to {card.wallet.phone ? `your phone ending ${String(card.wallet.phone).slice(-4)}` : "your email"} — change it under Apple Pay &amp; shipping below.</>
          : <>Your card needs your contact info on file at the bank before Wallet will accept it. Tap <strong className="text-ink">Enable wallet</strong>, then add the card manually in Wallet.</>}
      </div>
      {err && <div className="mt-2 text-[11px] text-clay" data-testid={`wallet-error-${cardKey}`}>{err}</div>}
    </div>
  );
}
